const items = document.querySelectorAll('.neos-contentcollection .time-line--item')

// Bootstrap breakpoints: sm 576, md 768, lg 992, xl 1200
// On small screens items are tall and need an earlier trigger (factor closer to 1.0)
const VIEWPORT_FACTORS = [
  { breakpoint: 1200, factor: 0.6 }, // xl+
  { breakpoint: 992, factor: 0.65 }, // lg
  { breakpoint: 768, factor: 0.8 }, // md
  { breakpoint: 576, factor: 0.8 }, // sm
  { breakpoint: 0, factor: 0.8 } // xs
]

function getViewportFactor () {
  const width = window.innerWidth
  return (VIEWPORT_FACTORS.find(({ breakpoint }) => width >= breakpoint) || VIEWPORT_FACTORS.at(-1)).factor
}

function isElementInViewport (el) {
  const rect = el.getBoundingClientRect()
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  return rect.top < viewportHeight * getViewportFactor() && rect.bottom > 0
}

function callbackFunc () {
  for (let i = 0; i < items.length; i++) {
    if (isElementInViewport(items[i])) {
      items[i].classList.add('in-view')
    }
  }
}

window.addEventListener('load', callbackFunc)
window.addEventListener('resize', callbackFunc)
window.addEventListener('scroll', callbackFunc)
